import Composer from './implementation';

export default Composer;
